var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload11(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2619_31171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9326 10.9395C17.8111 10.671 17.5441 10.5 17.2501 10.5H14.2501V0.75C14.2501 0.336 13.9141 0 13.5001 0H10.5001C10.0861 0 9.75009 0.336 9.75009 0.75V10.5H6.75009C6.45609 10.5 6.18909 10.6725 6.06759 10.9395C5.94459 11.208 5.99259 11.5215 6.18609 11.7435L11.4361 17.7435C11.5786 17.907 11.7841 18 12.0001 18C12.2161 18 12.4216 17.9055 12.5641 17.7435L17.8141 11.7435C18.0091 11.523 18.0541 11.208 17.9326 10.9395Z",
    fill: "#4B4446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 16.5V21H3.75V16.5H0.75V22.5C0.75 23.3295 1.422 24 2.25 24H21.75C22.5795 24 23.25 23.3295 23.25 22.5V16.5H20.25Z",
    fill: "#4B4446"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2619_31171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload11);
export default __webpack_public_path__ + "static/media/download 1 (1).81dde0c60d6b06ad557cc467fb2394b7.svg";
export { ForwardRef as ReactComponent };